import { visionLabApi } from '@/app/apiClient';
import type {
  AdminInvitationFilters,
  AdminInvitationPage,
  InvitationCancelReceipt,
  InvitationCommand,
  InvitationResendReceipt,
} from '@/features/invitations/types/adminInvitation';
import type { ApiCallOptions } from '@/shared/api/client';
import { type CommandOptions, commandOptions } from '@/shared/api/command';

export function fetchAdminInvitations(
  filters: AdminInvitationFilters = {},
  options: ApiCallOptions = {},
) {
  return visionLabApi.get<AdminInvitationPage>('/organization-invitations', {
    ...options,
    searchParams: {
      organizationId: filters.organizationId?.trim() || undefined,
      q: filters.q?.trim() || undefined,
      status: filters.status,
    },
  });
}

export function resendInvitation(input: InvitationCommand, options: CommandOptions) {
  return visionLabApi.post<InvitationResendReceipt>(
    `/organizations/${encodeURIComponent(input.organizationId)}/members/${encodeURIComponent(input.invitationId)}/resend`,
    { ...commandOptions(options), json: {} },
  );
}

export function cancelInvitation(input: InvitationCommand, options: CommandOptions) {
  return visionLabApi.post<InvitationCancelReceipt>(
    `/organizations/${encodeURIComponent(input.organizationId)}/members/${encodeURIComponent(input.invitationId)}/cancel`,
    { ...commandOptions(options), json: {} },
  );
}
